import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ProfileHeader from '../ProfileHeader/ProfileHeader';
import NewHeader from './NewHeader';
import { Space } from 'antd';

const PAGE_TITLES = {
    '/dashboard': 'Dashboard',
    '/lead/list': 'Leads',
    '/booking/list': 'Bookings',
    '/member/list': 'Members',
    '/visit/lead/list': 'Visit Leads',
};

const getPageTitle = () => {
    const path = window.location.pathname;
    if (PAGE_TITLES[path]) return PAGE_TITLES[path];
    if (path.includes('calendar')) return 'Calendar';
    if (path.includes('venue-updator')) return 'Venue Updator';
    if (path.includes('event')) return 'Lead Details';
    return 'Dashboard';
};

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isUserDropdownOpen: false,
            isSidebarHidden: false,
            isShowVenueDropdown: false
        };
    }

    handleVenueChange = (venue) => {
        this.setState({ isShowVenueDropdown: false });
        localStorage.setItem('active_venue', JSON.stringify(venue));
        this.props.handleChangeActiveVenue(venue);
    };

    render() {
        const isMobile = this.props.windowWidth < this.props.breakpoint;

        return (
            <>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

                    /* ===== COMMON ===== */
                    .vm-header-container {
                        background-color: #F5F7FB;
                        box-shadow: 0px 1px 0px #E9EDF3;
                    }
                    .header-outer-row {
                        background-color: #F5F7FB;
                    }
                    .header-wrapper {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        height: 100%;
                        background-color: var(--surface, #fff) !important;
                        border-bottom: 1px solid var(--border, #E5E7EB);
                        box-shadow: 0 1px 6px rgba(0,0,0,0.06);
                        box-sizing: border-box;
                    }
                    .header-wrapper *,
                    .header-outer-row,
                    .header-outer-row > [class*="col"] {
                        background-color: transparent;
                    }
                    .header-wrapper .btn-primary {
                        background-color: #2A52BB !important;
                        color: #ffffff !important;
                        border: none !important;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .header-wrapper .btn-primary:hover {
                        background-color: #1e3d96 !important;
                        color: #ffffff !important;
                    }
                    .header-right {
                        display: flex;
                        align-items: center;
                    }
                    .header-left {
                        display: flex;
                        align-items: center;
                    }
                    .header-brand {
                        display: none;
                    }
                    .header-hamburger {
                        display: none;
                    }

                    /* ===== DESKTOP ===== */
                    @media (min-width: 800px) {
                        .header-wrapper {
                            padding: 0 24px;
                        }
                        .header-right {
                            gap: 16px;
                        }
                        .header-page-title {
                            font-family: 'Outfit', sans-serif;
                            font-size: 22px;
                            font-weight: 800;
                            color: #111827;
                            letter-spacing: -0.5px;
                        }
                    }

                    /* ===== MOBILE ===== */
                    @media (max-width: 799px) {
                        .vm-header-container {
                            background-color: #111827 !important;
                            box-shadow: none !important;
                        }
                        .header-outer-row.is-authenticated {
                            background-color: #111827 !important;
                        }
                        .header-wrapper {
                            padding: 0 16px;
                        }
                        .header-wrapper.is-authenticated {
                            background-color: #111827 !important;
                            border-bottom: 1px solid #1f2937;
                            box-shadow: none;
                        }
                        .header-right {
                            gap: 12px;
                        }
                        .header-left {
                            display: flex;
                            align-items: center;
                            gap: 12px;
                        }
                        .header-brand {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                        }
                        .header-brand-logo {
                            width: 32px;
                            height: 32px;
                            border-radius: 8px;
                            background: linear-gradient(135deg, #5B7CFF 0%, #3B82F6 100%);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: white;
                            font-size: 13px;
                            font-weight: 800;
                        }
                        .header-brand-name {
                            color: white;
                            font-size: 15px;
                            font-weight: 800;
                            font-family: 'Poppins', sans-serif;
                        }
                        .header-hamburger {
                            display: flex !important;
                            align-items: center;
                            justify-content: center;
                            width: 42px;
                            height: 42px;
                            background: rgba(255, 255, 255, 0.08) !important;
                            border: 1px solid rgba(255, 255, 255, 0.15);
                            border-radius: 10px;
                            cursor: pointer;
                            padding: 0;
                            color: #d1d5db;
                            transition: background 0.2s ease;
                        }
                        .header-hamburger:hover {
                            background: rgba(255, 255, 255, 0.12) !important;
                            color: #ffffff;
                        }
                        .header-page-title {
                            display: none;
                        }
                    }
                `}</style>

                {/* Outer wrapper — forces bg color */}
                <div
                    className={`header-outer-row ${this.props.isAuthenticated ? 'is-authenticated' : ''}`}
                    style={{ width: '100%', height: '100%' }}
                >
                    <div className={`header-wrapper ${this.props.isAuthenticated ? 'is-authenticated' : ''}`}>

                        {/* LEFT */}
                        <div className="header-left">
                            {!this.props.isAuthenticated ? (
                                <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '9px', textDecoration: 'none' }}>
                                    <div style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '9px',
                                        background: 'linear-gradient(135deg, #5b8afb 0%, #3b6ef8 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#ffffff',
                                        fontSize: '13px',
                                        fontWeight: '800',
                                        boxShadow: '0 3px 10px rgba(59,110,248,0.35)',
                                        fontFamily: "'Outfit', sans-serif"
                                    }}>
                                        VM
                                    </div>
                                    <span style={{
                                        fontSize: '16px',
                                        fontWeight: '800',
                                        color: '#111827',
                                        letterSpacing: '-0.02em',
                                        fontFamily: "'Outfit', sans-serif"
                                    }}>
                                        VenueMonk
                                    </span>
                                </Link>
                            ) : (
                                <>
                                    {/* Hamburger — mobile only */}
                                    <button
                                        className="header-hamburger"
                                        onClick={this.props.toggleSideBar}
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                            <line x1="3" y1="6" x2="21" y2="6"/>
                                            <line x1="3" y1="12" x2="21" y2="12"/>
                                            <line x1="3" y1="18" x2="21" y2="18"/>
                                        </svg>
                                    </button>

                                    {/* Brand Logo & Name — mobile only */}
                                    <div className="header-brand">
                                        <div className="header-brand-logo">VM</div>
                                        <span className="header-brand-name">VenueMonk</span>
                                    </div>

                                    {/* Page Title — desktop only */}
                                    <span className="header-page-title">
                                        {getPageTitle()}
                                    </span>
                                </>
                            )}
                        </div>

                        {/* RIGHT */}
                        {this.props.isAuthenticated ? (
                            <div className="header-right">
                                {/* Venue Selector */}
                                <NewHeader
                                    windowWidth={this.props.windowWidth}
                                    breakpoint={this.props.breakpoint}
                                    venueList={this.props.venueList}
                                    venueDetails={this.props.venueDetails}
                                    activeVenue={this.props.activeVenue}
                                    handleChangeActiveVenue={this.handleVenueChange}
                                />
                                {/* User Profile */}
                                <ProfileHeader
                                    windowWidth={this.props.windowWidth}
                                    breakpoint={this.props.breakpoint}
                                />
                            </div>
                        ) : (
                            <Space size="middle" className="header-right">
                                <Link to="/login" style={{
                                    color: '#4b5563',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    fontFamily: "'Outfit', sans-serif",
                                    textDecoration: 'none'
                                }}>
                                    LOGIN
                                </Link>
                                {!isMobile && (
                                    <Link
                                        to="/choose-your-business"
                                        style={{
                                            height: '40px',
                                            padding: '8px 18px',
                                            borderRadius: '9px',
                                            background: 'linear-gradient(135deg,#5b8afb,#3b6ef8)',
                                            color: '#fff',
                                            border: 'none',
                                            fontFamily: "'Outfit', sans-serif",
                                            fontSize: '13px',
                                            fontWeight: '700',
                                            cursor: 'pointer',
                                            boxShadow: '0 3px 10px rgba(59,110,248,0.28)',
                                            textDecoration: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        LIST YOUR BUSINESS
                                    </Link>
                                )}
                            </Space>
                        )}

                    </div>
                </div>
            </>
        );
    }
}

export default Header;